import { InternalAccessoryConfig } from './internal-accessory-config.model';

export class SegmentConfig {
  floaterConfig: InternalAccessoryConfig[];
  strakeConfig: InternalAccessoryConfig[];
  flexjointBeginId: number;
  stiffenerBeginId: number;
  flexjointEndId: number;
  stiffenerEndId: number;
  orientation: string;
}
